import { render, staticRenderFns } from "./ApiOrderList.vue?vue&type=template&id=1c207980"
import script from "./ApiOrderList.vue?vue&type=script&lang=js"
export * from "./ApiOrderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports